import { svgToIcon } from '../../utils/svg';
import Tool, { type IToolAvailableInput, simpleToolButton } from '../Tool';
import ToolWireframe from './ToolWireframe';
import wireframeDeleteItem from '../../assets/icons/wireframeDeleteItem.svg';

// This tool allows a user to add an additional item to a wireframe, e.g., another
// nav menu item for a nav menu wireframe component.
class ToolWireframeDeleteItem extends ToolWireframe {
  static toolName = 'Delete item';

  static action({ controller, selection }) {
    selection.wireframe.deleteItem();
    Tool.toolActionComplete({ controller });
  }

  static enabled({ selection }: { controller: any; selection: any }): boolean {
    return selection.type === 'wireframe';
  }

  static available({ selection }: IToolAvailableInput) {
    return selection?.type === 'wireframe';
  }

  static buttonComponent() {
    return simpleToolButton(
      ToolWireframeDeleteItem,
      svgToIcon(wireframeDeleteItem)
    );
  }
}

export default ToolWireframeDeleteItem;
